<template>
  <layout-editor-page
    :title="formTitle"
    isTabsPage
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="hasCreateNew"
    :isCancel="!hasCreateNew"
    @command="setCommand"
  >
    <el-tabs v-model="activeTab">
      <el-tab-pane name="general">
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('general')}}</span>
        </template>
        <layout-scroll-content>
          <form-general
            ref="Form"
            :disabled="disabled"
            :data="data"
            :model="formModel"
            @updateModelItem="handlerUpdateModelItem"
            @change="handleFormData"/>
          <template v-slot:footer>
            <form-controls
              class="form-footer"
              :isCreate="!hasCreateNew"
              :isSave="hasCreateNew && !disabled"
              :isDelete="hasCreateNew && !disabled"
              @command="setCommand"/>
          </template>
        </layout-scroll-content>
      </el-tab-pane>
      <el-tab-pane name="list-grid" :disabled="!hasCreateNew">
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('forwarders')}}</span>
        </template>
        <list-grid
          :disabled="disabled"
          :currentID="currentID"
        />
      </el-tab-pane>
    </el-tabs>
  </layout-editor-page>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'

export default {
  name: 'EditorShippers',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'layout-scroll-content': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/EditorPage/ScrollContent.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'form-general': () => import(/* webpackChunkName: 'Shippers' */ './FormGeneral'),
    'list-grid': () => import(/* webpackChunkName: 'Shippers' */ './ForwardersShipper/Index.vue')
  },
  data: () => ({
    activeTab: 'general',
    // eslint-disable-next-line
    apiPatch: 'Shippers/Patch/${data.id}'
  }),
  computed: {
    formTitle () {
      return this.formData.shipperName || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        shipperName: '',
        contactName: '',
        contactPhone: ''
      }
    }
  }
}
</script>

<style lang="stylus">
</style>
